<template>
  <div class="card-game-step">
    <game-template :success="cardIndex + 1 === cards.length && isStackClickable">
      <template v-if="cardIndex + 1 === cards.length && isStackClickable" v-slot:head>
        <p class="title">
          Vous avez placé toutes les cartes !
        </p>
        <button @click="next" class="button">Continuer</button>
      </template>
      <template v-else v-slot:head>
        <p class="title">
          Déposez les cartes présentées dans les bonnes boîtes !
        </p>
        <p class="sub-title">
          Chaque carte bien placée vous fait gagner 1 point.
        </p>
      </template>
      <template v-slot:content>
        <div class="card-game">
          <div class="game-area">
            <div class="boxes">
              <div class="box" :class="{ 'is-ie': $browserDetect.isIE || $browserDetect.isEdge }" v-for="(box, index) in boxes" :key="box.name">
                <div class="mini-cards-stack">
                  <div v-for="card in box.answers" :key="'mini-card' + card" class="mini-card"></div>
                </div>
                <p class="label">
                  {{ box.label }}
                </p>
                <transition name="fade">
                  <div
                    v-show="cardIndex > -1"
                    class="dropzone-wrapper"
                    :class="{ 'clickable': isDropZoneClickable }"
                    @click="onDropZoneClick(box.name, currentCard.destinations.length - answers.length)"
                  >
                    <drop
                      class="drop-zone"
                      :class="{ 'drag-hover': isDropZoneHover[index], 'hidden': isStackClickable }"
                      @drop="onCardDrop(box.name, ...arguments)"
                      @dragover="setDropZoneHover(index, true)"
                      @dragleave="setDropZoneHover(index, false)">
                      <div
                        v-show="showCardOnDropZone(box.name)"
                        class="card"
                        :style="{ backgroundImage: `url(${require(`../assets/card-game/cards/${currentCard.img}.svg`)})` }">
                      </div>
                      <transition name="fade">
                        <div class="answer-bloc" v-show="showAnswers && box.statut === 'right'">
                          <div
                            class="card"
                            :style="{ backgroundImage: `url(${require(`../assets/card-game/cards/${currentCard.img}.svg`)})` }">
                          </div>
                          <div class="right-answer answer"></div>
                        </div>
                      </transition>
                      <transition name="fade">
                        <div class="answer-bloc" v-show="showAnswers && box.statut === 'wrong'">
                          <div
                            class="card"
                            :style="{ backgroundImage: `url(${require(`../assets/card-game/cards/${currentCard.img}.svg`)})` }">
                          </div>
                          <div class="wrong-answer answer"></div>
                        </div>
                      </transition>
                    </drop>
                  </div>
                </transition>
              </div>
            </div>
            <div class="card-info-wrapper">
              <transition name="fade">
                <div v-if="currentCard.info && isStackClickable" class="card-info">
                  {{ currentCard.info }}
                </div>
              </transition>
            </div>
            <div class="cards">
              <div class="card-stack">
                <div class="score-bloc">
                  <p class="score-label">score</p>
                  <p class="score">{{ score }}</p>
                </div>
                <div class="stack" :class="{ clickable: isStackClickable }" @click="startTurn">
                </div>
              </div>
              <transition name="fade">
                <div class="current-card" v-show="isCurrentCardVisible">
                  <div
                    class="card-placeholder"
                    :class="{ 'transparent': isStackClickable}"
                    v-for="index in currentCard.destinations.length"
                    :key="'card' + index">
                    <transition name="fade">
                      <div class="test-ie" v-show="!isCurrentCardDragging[index - 1]">
                        <drag
                          class="card"
                          :style="{ backgroundImage: `url(${require(`../assets/card-game/cards/${currentCard.img}.svg`)})` }"
                          :transfer-data="index"
                          :image-x-offset="30"
                          :image-y-offset="30"
                          @dragstart="handleDragStart(index, ...arguments)"
                          @dragend="handleDragEnd(index, ...arguments)"
                        >
                          <template slot="image" v-if="!$browserDetect.isSafari">
                            <div class="card draggable-cursor" :style="{ backgroundImage: `url(${require(`../assets/card-game/cards/${currentCard.img}.svg`)})` }"></div>
                          </template>
                        </drag>
                      </div>
                    </transition>
                  </div>
                  <div class="card-label" :class="{ 'show-arrow': !isDragging }">{{ currentCard.label }}</div>
                </div>
              </transition>
              <div class="cards-dialog">
                <dialog-box
                  :is-visible="cardIndex === -1"
                  arrow-position="left"
                >
                  Cliquez sur la pioche pour commencer
                </dialog-box>
              </div>
              <div class="cards-dialog">
                <dialog-box
                  :is-visible="(cardIndex !== cards.length - 1) && isStackClickable && showContinueDialog"
                  arrow-position="left"
                >
                  Cliquez sur la pioche pour continuer
                </dialog-box>
              </div>
            </div>
            <popup title="Les règles de la déclaration d'absence">
              <template v-slot:button>
                <button class="popup-button">
                  Les règles de la <br>
                  déclaration d'absence
                </button>
              </template>
              <template v-slot:content>
                <img src="../assets/card-game/popup-absences.png">
              </template>
            </popup>
          </div>
        </div>
        <button v-if="cardIndex + 1 === cards.length && isStackClickable" @click="next" class="button card-exit-button">Continuer</button>
      </template>
    </game-template>
  </div>
</template>

<script>
import { Drag, Drop } from 'vue-drag-drop'
import DialogBox from '@shared/components/DialogBox'
import Popup from '@shared/components/Popup'
import stepMixin from '@shared/mixins/stepMixin'

export default {
  name: 'DropCardsGame',
  mixins: [stepMixin],
  components: {
    Drop,
    Drag,
    DialogBox,
    Popup
  },
  data () {
    return {
      hideScrollArrow: true,
      score: 0,
      boxes: [
        {
          name: 'cp',
          label: 'CP',
          statut: '',
          answers: 0
        },
        {
          name: 'arret',
          label: 'Arrêt maladie',
          statut: '',
          answers: 0
        },
        {
          name: 'rtt',
          label: 'RTT',
          statut: '',
          answers: 0
        },
        {
          name: 'defausse',
          label: 'Aucun',
          statut: '',
          answers: 0
        }
      ],
      cards: [
        {
          name: 'card_1',
          label: 'Je dois être déclaré(e) du premier jour d’absence jusqu’à la veille de la reprise (même s’il s’agit d’un jour férié, d’un repos, ou d’un dimanche)',
          img: 'card-semainier',
          destinations: ['cp']
        },
        {
          name: 'card_2',
          label: 'Le contrat à temps partiel diminue le nombre de jours acquis',
          img: 'card-mi-temps',
          destinations: ['defausse'],
          info: 'Qu’importe le contrat, tous les salariés acquièrent le même nombre de congés payés.'
        },
        {
          name: 'card_3',
          label: 'Je dois être pris régulièrement conformément à l’accord en vigueur et être planifié plusieurs mois à l’avance',
          img: 'card-calendar',
          destinations: ['cp', 'rtt']
        },
        {
          name: 'card_4',
          label: 'Quel que soit le planning, pour une semaine complète posée (du lundi au dimanche), 5 jours sont décomptés',
          img: 'card-5',
          destinations: ['cp']
        },
        {
          name: 'card_5',
          label: 'Je déclenche une majoration pour heures supplémentaires',
          img: 'card-no-majoration',
          destinations: ['defausse'],
          info: 'Les CP, RTT, maladie et RECUP ne sont pas assimilés à du temps de travail effectif. Il n’y aura pas de majoration en cas d’heures excédentaires.'
        },
        {
          name: 'card_6',
          label: 'Je dois être déclaré(e) du lendemain du dernier jour travaillé jusqu’à la date de reprise',
          img: 'card-no-declaration',
          destinations: ['arret']
        },
        {
          name: 'card_7',
          label: 'Pas de report des soldes en fin de période',
          img: 'card-sold-out',
          destinations: ['cp', 'rtt']
        },
        {
          name: 'card_8',
          label: 'Mon justificatif est impérativement envoyé à la gestionnaire de paie après saisie en GTA',
          img: 'card-mail-rh',
          destinations: ['arret']
        },
        {
          name: 'card_9',
          label: 'Avec la GTA plus aucun document papier n\'est utilisé',
          img: 'card-no-paper',
          destinations: ['defausse'],
          info: 'L’objectif de la GTA est de réduire le recours au papier, néanmoins  pour les salariés ne pouvant pas faire leur demande en ligne, il est obligatoire de maintenir la demande via le formulaire prévu à cet effet.'
        }
      ],
      cardIndex: -1,
      isCurrentCardVisible: false,
      isCurrentCardDragging: [],
      isStackClickable: true,
      showAnswers: false,
      answers: [],
      isDropZoneHover: [],
      showContinueDialog: false,
      continueDialogTimeout: null,
      shouldTriggerDragEndOnIE: true
    }
  },
  computed: {
    currentCard () {
      return this.cardIndex === -1 ? this.cards[0] : this.cards[this.cardIndex]
    },
    isDropZoneClickable () {
      return this.currentCard.destinations.length !== this.answers.length && !this.isStackClickable
    },
    remainingCards () {
      return this.cards.reduce((nbCards, card) => {
        return this.cards.indexOf(card) > this.cardIndex ? nbCards + card.destinations.length : nbCards
      }, 0)
    },
    isDragging () {
      return this.isCurrentCardDragging.filter(isDrag => isDrag).length === this.isCurrentCardDragging.length
    }
  },
  methods: {
    startTurn () {
      if (this.isStackClickable && (this.cardIndex + 1 !== this.cards.length)) {
        this.showAnswers = false
        this.isCurrentCardDragging = []
        this.isCurrentCardVisible = true
        this.isStackClickable = false
        if (this.cardIndex < this.cards.length - 1) {
          this.cardIndex++
        }
        this.boxes.forEach(box => {
          box.statut = ''
          this.isDropZoneHover.push(false)
        })
        this.currentCard.destinations.forEach(() => {
          this.isCurrentCardDragging.push(false)
        })
        this.showContinueDialog = false
        clearTimeout(this.continueDialogTimeout)
      }
    },
    endTurn () {
      let score = 0
      this.answers.forEach(answer => {
        if (this.currentCard.destinations.includes(answer)) {
          score++
        }
      })
      this.currentCard.destinations.forEach(destination => {
        this.boxes[this.getBoxIndexFromName(destination)].answers++
      })
      this.score += score
      this.showAnswers = true
      this.isStackClickable = true
      this.isDropZoneHover = []
      this.answers = []
      // start timer to display continue dialog after a 5seconds idle time
      this.continueDialogTimeout = setTimeout(() => {
        this.showContinueDialog = true
      }, 2000)

      this.$store.commit('setCardGameScore', this.score)

      if (this.cardIndex + 1 === this.cards.length && this.isStackClickable) {
        window.scrollTo(0, 0)
      }
    },
    showCardOnDropZone (dropZone) {
      return this.answers.includes(dropZone)
    },
    handleDragStart (cardIndex, transferData, nativeEvent) {
      if (this.$browserDetect.isIE || this.$browserDetect.isEdge) {
        this.shouldTriggerDragEndOnIE = true
      }
      document.body.classList.add('draggable-cursor')
      this.$set(this.isCurrentCardDragging, cardIndex - 1, true)
    },
    handleDragEnd (cardIndex, transferData, nativeEvent) {
      document.body.classList.remove('draggable-cursor')
      if (nativeEvent.dataTransfer.dropEffect === 'none' && nativeEvent.type === 'dragend') {
        if (this.$browserDetect.isIE || this.$browserDetect.isEdge) {
          if (this.shouldTriggerDragEndOnIE) {
            this.$set(this.isCurrentCardDragging, cardIndex - 1, false)
          }
        } else {
          this.$set(this.isCurrentCardDragging, cardIndex - 1, false)
        }
      }
    },
    setDropZoneHover (dropZoneIndex, value) {
      this.$set(this.isDropZoneHover, dropZoneIndex, value)
    },
    getBoxIndexFromName (name) {
      return this.boxes.indexOf(this.boxes.filter(box => box.name === name)[0])
    },
    alreadyDroppedHere (dropZone) {
      return this.answers.includes(dropZone)
    },
    onDropZoneClick (dropZone, cardIndex) {
      if (this.isDropZoneClickable && !this.alreadyDroppedHere(dropZone)) {
        this.onCardDrop(dropZone, cardIndex)
      }
    },
    onCardDrop (dropZone, cardIndex) {
      if (this.$browserDetect.isIE || this.$browserDetect.isEdge) {
        this.shouldTriggerDragEndOnIE = false
      }
      if (!this.alreadyDroppedHere(dropZone)) {
        this.$set(this.isCurrentCardDragging, cardIndex - 1, true)
        this.answers.push(dropZone)
      } else {
        this.$set(this.isCurrentCardDragging, cardIndex - 1, false)
      }
      if (this.answers.length === this.currentCard.destinations.length) {
        this.handleAnswers()
      }
    },
    handleAnswers () {
      const allAnswers = [...new Set(this.answers.concat(this.currentCard.destinations))]
      allAnswers.forEach(answer => {
        if (this.currentCard.destinations.includes(answer)) {
          this.boxes[this.getBoxIndexFromName(answer)].statut = 'right'
        } else {
          this.boxes[this.getBoxIndexFromName(answer)].statut = 'wrong'
        }
      })
      window.setTimeout(this.endTurn, 500)
    }
  }
}
</script>

<style lang=scss>
  @mixin drop-zone-hover {
    background-color: rgba(#b8b8b8, 0.6);
    border-style: solid;
    &:before {
      content: 'Cliquez ou déposez une carte';
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: 900;
      font-style: italic;
      position: absolute;
      padding: 0 15px;
      width: 125px;
      height: 180px;
    }
  }

  .card-game {
    flex-grow: 1;
    min-height: 610px;
    display: flex;
    flex-direction: column;
    .game-area {
      flex-grow: 1;
      padding: 15px 15px 0 15px;
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      overflow: hidden;
      user-select: none;
      position: relative;
      .boxes {
        display: flex;
        justify-content: center;
        position: relative;
        padding-bottom: 150px;
        .box {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          background-color: $primary-color;
          width: 302px;
          height: 180px;
          position: relative;
          background-image: url('../assets/card-game/box-audit-bg.svg');
          background-blend-mode: multiply;
          background-repeat: no-repeat;
          &.is-ie {
            &:before{
              content:'';
              background: transparentize(darken(#2b92c1, 8), .5);
              position: absolute;
              top:0;
              bottom:0;
              width:100%;
              height: 100%;
            }
            &:nth-child(1) {
              &:before {
                background-color: rgba(#2b92c1, .8);
              }
            }
            &:nth-child(2) {
              &:before {
                background-color: rgba(#2b92c1, .8);
              }
            }
            &:nth-child(3) {
              &:before {
                background-color: rgba(#2b92c1, .8);
              }
            }
            &:nth-child(4) {
              &:before {
                background-color: rgba(#2b92c1, .8);
              }
            }
            .label {
              position: relative;
            }
          }
          &:nth-child(1) {
            background-color: #2b92c1;
          }
          &:nth-child(2) {
            background-color: #326db1;
          }
          &:nth-child(3) {
            background-color: #20a8c1;
          }
          &:nth-child(4) {
            background-color: #2b5f77;
          }
          .mini-cards-stack {
            position: absolute;
            width: 287px;
            height: 58px;
            top: 7px;
            left: 7px;
            display: flex;
            align-items: center;
            .mini-card {
              height: 100%;
              margin-right: 1px;
              width: 3px;
              background-image: url('../assets/card-game/card-inbox.svg');
              background-repeat: no-repeat;
            }
          }
          .label {
            margin-top: 40px;
            font-size: 1.25rem;
            font-weight: 700;
          }
          .dropzone-wrapper {
            position: absolute;
            top: 150px;
            width: 130px;
            height: 180px;
            left: 50%;
            transform: translateX(-50%);
            &.clickable {
              cursor: pointer;
              &:hover {
                .drop-zone {
                  @include drop-zone-hover;
                }
              }
            }
            .drop-zone {
              width: 130px;
              height: 180px;
              border: 1px dashed #da0a2b;
              background-color: rgba(255, 88, 43, 0.15);
              border-radius: 10px;
              position: absolute;
              z-index: 2;
              &.drag-hover {
                cursor: grab;
                @include drop-zone-hover;
              }
              &.hidden {
                background-color: transparent;
                border: none;
              }
              .answer-bloc {
                position: relative;
                .answer {
                  position: absolute;
                  background-repeat: no-repeat;
                  width: 100%;
                  height: 100%;
                  top: 0;
                  left: 0;
                  background-position: center;
                  background-size: 120px;
                  border-radius: 10px;
                  &.wrong-answer {
                    background-color: rgba(#4d4d4f, 0.75);
                    background-image: url('../assets/card-game/wrong_bubble.svg');
                  }
                  &.right-answer {
                    background-image: url('../assets/card-game/right_bubble.svg');
                  }
                }
              }
            }
          }
        }
        .box + .box {
          margin-left: 15px;
        }
        .boxes-dialog {
          position: absolute;
          top: 230px;
          right: 0;
          &.bottom {
            top: 528px;
          }
          p {
            display: flex;
            align-items: center;
            .popup-button {
              position: static;
              margin: 0 10px;
              cursor: default;
            }
          }
        }
      }
      .card-info-wrapper {
        height: 75px;
        margin-top: 40px;
        margin-bottom: 10px;
        .card-info {
          background-color: #fff;
          box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.16);
          height: 75px;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          padding-left: 75px;
          border-radius: $radius-sm;
          &:before {
            content: 'i';
            font-family: Georgia, "Times New Roman", serif;
            font-size: 1.4rem;
            background-color: $primary-text-color;
            color: #fff;
            font-weight: 700;
            width: 75px;
            height: 75px;
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
      .cards {
        display: flex;
        position: relative;
        .card-stack {
          position: relative;
          top: 30px;
          margin-left: 50px;
          .score-bloc {
            margin-bottom: 20px;
            text-align: left;
            .score-label {
              text-transform: uppercase;
              font-size: 0.9rem;
              font-family: $secondary-font;
              color: $secondary-text-color;
            }
            .score {
              font-size: 1.25rem;
              font-weight: bold;
            }
          }
          .stack {
            position: relative;
            &.clickable {
              cursor: pointer;
            }
            background-image: url('../assets/card-game/cards/card-stack.svg');
            width: 143px;
            height: 190px;
            box-shadow: 0 22px 5px rgba(128, 128, 128, 0.5);
            .remaining-cards {
              position: absolute;
              top: 50px;
              left: 10px;
              color: #fff;
              font-weight: 700;
              width: 110px;
              text-align: center;
              span {
                font-size: 1.8rem;
              }
            }
          }
        }
        .current-card {
          margin-left: 50px;
          display: flex;
          align-items: center;
          .card-label {
            margin-left: 35px;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.16);
            padding: 0 25px;
            font-size: 1.1rem;
            border-radius: 4px;
            font-weight: 900;
            align-self: flex-start;
            margin-top: 40px;
            position: relative;
            &.show-arrow {
              &:after {
                content: '';
                background-image: url('../../../shared/assets/icons/arrowDown-white.svg');
                position: absolute;
                display: inline-block;
                width: 16px;
                height: 30px;
                left: -20px;
                top: 50%;
                transform: translateY(-50%) rotate(90deg);
              }
            }
          }
          .card-placeholder {
            width: 130px;
            min-width: 130px;
            height: 180px;
            background-color: rgba(#b8b8b8, 0.4);
            border-radius: 10px;
            &.transparent {
              background-color: transparent;
            }
            .test-ie.invisible-if-is-ie {
              display: none;
              opacity: 0;
            }
            .card {
              cursor: grab;
              &:active {
                cursor: grabbing;
              }
            }
          }
          .card-placeholder + .card-placeholder {
            margin-left: -108px;
            background-color: transparent;
          }
        }
        .cards-dialog {
          position: absolute;
          top: 170px;
          left: 250px;
        }
      }
      .popup-button {
        position: absolute;
        right: 25px;
        bottom: 20px;
      }
      .card-game-next-button {
        width: 180px;
        position: absolute;
        left: 50%;
        bottom: 50px;
        transform: translateX(-50%);
      }
    }
    .card {
      position: relative;
      background-size: 100% 100%;
      background-color: #fff;
      width: 130px;
      height: 180px;
      border-radius: 10px;
      box-shadow: 1px 1px 5px rgba(128, 128, 128, 0.9);
      user-select: none;
    }
  }
  .card-game-step {
    position: relative;
  }
  .card-exit-button {
    max-width: 190px;
    position: absolute;
    left: 50%;
    bottom: 10px;
    transform: translateX(-50%);
  }
</style>
